module.exports = __webpack_public_path__ + "static/img/a067.1d16e35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a067.jpg
// module id = ilBR
// module chunks = 0